// SF5 — terms carrying more than one of the seller's products.
//
// The finding is the split, not the overlap: one product holding a click share
// well above its impression share is the listing that should own the term, and
// the others are consuming its visibility.
import React from 'react';
import s from '../TermPerformance.module.css';
import { num, pct } from '../format';

export default function Cannibalization({ data, includeVariations, onToggleVariations }) {
  if (!data) return <div className={s.empty}>Loading…</div>;

  return (
    <>
      <div className={s.controls} style={{ marginBottom: 12 }}>
        <label className={s.field} style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" checked={includeVariations}
                 onChange={(e) => onToggleVariations(e.target.checked)} />
          <span className={s.label} style={{ margin: 0 }}>
            Include variation children
          </span>
        </label>
        <span className={s.hint}>
          Excluded by default: Amazon treats a variation family as one listing, so children
          appearing together is normal coverage rather than self-competition.
        </span>
      </div>

      {!data.findings?.length ? (
        <div className={s.empty}>
          No term carries enough of your products, with enough impressions behind them, to
          read as self-competition rather than normal coverage.
        </div>
      ) : (
        data.findings.map((f) => {
          const leader = f.products.reduce((a, b) =>
            (b.efficiency || 0) > (a.efficiency || 0) ? b : a, f.products[0]);
          return (
            <div key={f.search_term} className={s.section}>
              <div className={s.sectionTitle}>
                {f.search_term}
                <span className={s.muted}> · {f.products.length} of your products</span>
              </div>
              <div className={s.tableWrap}>
                <table className={s.table}>
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th className={s.numeric}>Impressions</th>
                      <th className={s.numeric}>Share of them</th>
                      <th className={s.numeric}>Clicks</th>
                      <th className={s.numeric}>Share of them</th>
                      <th className={s.numeric}>Efficiency</th>
                    </tr>
                  </thead>
                  <tbody>
                    {f.products.map((p) => (
                      <tr key={p.asin}>
                        <td className={s.asin}>
                          {p.asin}
                          {p.asin === leader.asin && (
                            <span className={s.tagBase}> should own it</span>
                          )}
                        </td>
                        <td className={s.numeric}>{num(p.impressions)}</td>
                        <td className={s.numeric}>{pct(p.impression_split, 0)}</td>
                        <td className={s.numeric}>{num(p.clicks)}</td>
                        <td className={s.numeric}>{pct(p.click_split, 0)}</td>
                        <td className={s.numeric}>
                          <span className={p.efficiency >= 1 ? s.up : s.down}>
                            {(p.efficiency ?? 0).toFixed(2)}×
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })
      )}
    </>
  );
}
